import React from 'react';

export const VEHICLE_DISCLAIMER_VERSION = 1;

const HIGH_VALUE_CATEGORY_LABELS = new Set([
  'vehicles',
  'vehicle',
  'rv',
  'utv/atv',
  'atv/utv',
  'aviation',
]);

function normalizeCategoryName(name) {
  return String(name || '')
    .trim()
    .toLowerCase()
    .replace(/\s*\/\s*/g, '/')
    .replace(/\s+/g, ' ');
}

export function getCategoryDisplayName(categoryId, categories = []) {
  const category = categories.find((cat) => cat.id === categoryId);
  return category?.name || '';
}

export function isVehicleDisclaimerCategory(categoryId, categories = []) {
  if (!categoryId) return false;
  const category = categories.find((cat) => cat.id === categoryId);
  if (!category?.name) return false;
  return HIGH_VALUE_CATEGORY_LABELS.has(normalizeCategoryName(category.name));
}

export function isVehicleDisclaimerGear(gear, categories = []) {
  return Boolean(gear?.category && isVehicleDisclaimerCategory(gear.category, categories));
}

const OWNER_ACK_TEXT =
  'I understand and agree. I will coordinate insurance with renters and set the condition guarantee hold to the insurance deductible.';

const RENTER_ACK_TEXT =
  'I understand and agree. I accept these terms and will coordinate insurance with the owner as needed.';

export function VehicleCategoryDisclaimerBanner({
  acknowledged,
  onAcknowledgedChange,
  categoryName = '',
  variant = 'owner',
}) {
  const isRenter = variant === 'renter';
  const label = categoryName || 'this category';

  return (
    <div className="vehicle-disclaimer-banner" role="region" aria-label="High-value rental notice">
      <p className="vehicle-disclaimer-banner-title">
        Important notice — {label} rentals
      </p>
      <div className="vehicle-disclaimer-banner-body">
        <p>
          ATTACK! Your Adventure is a peer-to-peer rental marketplace. We are not responsible for
          damage to the rented item or for its condition before, during, or after a rental.
        </p>
        <p>
          {isRenter ? 'You and the owner' : 'Renters and owners'} are expected to arrange appropriate
          insurance coverage directly with one another.
          {isRenter
            ? ' Any condition guarantee hold typically aligns with the applicable insurance deductible.'
            : ' For listings in this category, set your condition guarantee hold to match the applicable insurance deductible.'}
        </p>
        <p>
          We do not bundle insurance into our platform{isRenter ? '' : ' so you can maximize your rental earnings'}.
          Adding that coverage would require us to charge substantially more for this service.
        </p>
      </div>
      <label className="vehicle-disclaimer-banner-ack">
        <input
          type="checkbox"
          checked={acknowledged}
          onChange={(e) => onAcknowledgedChange(e.target.checked)}
        />
        <span>{isRenter ? RENTER_ACK_TEXT : OWNER_ACK_TEXT}</span>
      </label>
    </div>
  );
}